export default __webpack_public_path__ + "static/media/FotoJorge.4d4872c4.jpg";